import React, { useState } from 'react'
import { AsyncTypeahead } from 'react-bootstrap-typeahead'
import { Form } from 'react-bootstrap'
import axios from 'axios'
import { useSelector } from 'react-redux'

const LandingScreen = ({history}) => {

  const [isLoading, setIsLoading] = useState(false)
  const [mesta, setMesta] = useState([])

  const userLogin = useSelector(state => state.userLogin)
  const { userInfo } = userLogin

  const searchHandler = (query) => {
    setIsLoading(true)

    if (userInfo) {
      const config = {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${userInfo.token} `
        }
      }
  
      axios.get(`/api/mesta/?abr=${query}`, config).then(item => {
        setMesta(item.data)
        setIsLoading(false)
      })
  
    } else {
      axios.get(`/api/mesta/citizens/?abr=${query}`).then(item => {
        setMesta(item.data)
        setIsLoading(false)
      })
    }
  } 

  const filterBy = () => true

  return (
    <div>
      {/* <AsyncTypeahead 
      filterBy={filterBy}
      id='basic-example' 
      labelKey='naziv'
      isLoading={isLoading}
      minLength={3}
      onSearch={searchHandler}
      options={mesta}
      placeholder='Izaberi grad'
      renderMenuItemChildren={(mesto) => (
        <div onClick={() => {
          history.push(`/home/${mesto._id}`)
        }}>
        <span>{mesto.naziv}</span>
        </div>
        
      )}
      /> */}
      <Form.Group className="mb-3">
         <Form.Label>Izaberi naseljeno mesto</Form.Label>
        <Form.Control as='select' onChange={(e) => {
          history.push(`/home/${e.target.value}`)
        }}>
          <option value='606a0acd3ec0452630fe298f'>...</option>
          <option value='606a0acd3ec0452630fe298f'>Temerin</option>
          <option value='606a14a464f2e5269ca03fa0'>Bački Jarak</option>
          <option value='606a0a644408b0352cd22c4a'>Sirig</option>
        </Form.Control> 
      </Form.Group>
    </div>
  )
}

export default LandingScreen
